import React, { useState } from "react";
import Image from "next/image";
import { cn } from "../../lib/utils";
import { useStudio } from "../../hooks/useStudio";
import { useConfiguratorContext } from "@studio3dx/legacy-use-configurator/react";
import EnquiryDialog from "./EnquireDialog";
import SaveCodeDialog from "./SaveCodeDialog";
import { EnvironmentSwitcher } from "./EnvironmentSwitcher";

interface ConfiguratorHeaderProps {
  isMobile?: boolean;
  /** Narrow / split layout: show compact header actions (no full desktop toolbar). */
  isMobileOrTablet?: boolean;
}

export const ConfiguratorHeader: React.FC<ConfiguratorHeaderProps> = ({
  isMobile = false,
  isMobileOrTablet = false,
}) => {
  const { configuratorName } = useConfiguratorContext();
  const studio = useStudio();

  return (
    <div
      className={cn(
        "px-4 md:px-8 py-2 flex justify-between items-center bg-white/90 backdrop-blur-md",
        "border-b border-gray-200"
      )}
    >
      <div className="flex items-center min-w-0 flex-1">
        <Image
          src="/caroffshore-logo.png"
          width={64}
          height={64}
          alt="car off shore logo"
          className="mr-3 h-auto w-auto max-h-16"
        />
      </div>

      <div
        className={cn(
          "flex items-center gap-2 flex-shrink-0",
          !isMobileOrTablet && "gap-8"
        )}
      >
        <div
          className={cn(
            "hidden items-center gap-4",
            !isMobileOrTablet && "flex"
          )}
        >
          <EnvironmentSwitcher />
          <EnquiryDialog />
          <SaveCodeDialog />
        </div>

        {/* Mobile/Tablet Action Buttons */}
        <div
          className={cn(
            "hidden items-center gap-2",
            isMobileOrTablet && "flex"
          )}
        >
          <EnquiryDialog label="Learn More" />
        </div>
      </div>
    </div>
  );
};
